import { CpServiceId } from "@climatepartner/utils";

import { APP_SERVICE_IDS } from "../../shared/config/app-services";
import { ANALYTICS_PATH } from "../../shared/routing/paths/analytics";
import { HOMESCREEN_PATH } from "../../shared/routing/paths/app";
import { COMMUNICATION_PATH, COMMUNICATION_REPORTS_PATH } from "../../shared/routing/paths/communication";
import { DOCUMENTS_PATH } from "../../shared/routing/paths/documents";
import { ACADEMY_PATH, CONTRIBUTE_PATH, SOLUTIONS_PATH } from "../../shared/routing/paths/hub";
import { NETWORK_PATH } from "../../shared/routing/paths/network";
import { REDUCTION_PATH } from "../../shared/routing/paths/reduction";

const isUnder = (pathname: string, base: string): boolean => pathname === base || pathname.startsWith(`${base}/`);

// `/` renders the hub in place (see `HomeEntryRoute`), so the sidebar must highlight Home
// there. Matched exactly — every other path starts with "/" too.
const isHubRoot = (pathname: string): boolean => pathname === HOMESCREEN_PATH;

/**
 * Maps a pathname to the service used by the AppShell sidebar and Localize labels.
 */
export const getCurrentServiceId = (pathname: string): CpServiceId => {
  if (isUnder(pathname, NETWORK_PATH)) {
    return APP_SERVICE_IDS.NETWORK;
  }
  if (isUnder(pathname, CONTRIBUTE_PATH)) {
    return APP_SERVICE_IDS.CONTRIBUTE;
  }

  if (isUnder(pathname, REDUCTION_PATH)) {
    return APP_SERVICE_IDS.REDUCTION;
  }
  if (isUnder(pathname, ANALYTICS_PATH)) {
    return APP_SERVICE_IDS.ANALYTICS;
  }
  if (isUnder(pathname, DOCUMENTS_PATH)) {
    return APP_SERVICE_IDS.DOCUMENTS;
  }
  if (isUnder(pathname, COMMUNICATION_REPORTS_PATH)) {
    return APP_SERVICE_IDS.COMMUNICATION_REPORTS;
  }
  if (isUnder(pathname, COMMUNICATION_PATH)) {
    return APP_SERVICE_IDS.COMMUNICATION;
  }
  if (isHubRoot(pathname) || isUnder(pathname, ACADEMY_PATH) || isUnder(pathname, SOLUTIONS_PATH)) {
    return APP_SERVICE_IDS.HOMESCREEN;
  }
  return APP_SERVICE_IDS.CFC;
};
